'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'signal-stream';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f8dd';
var svgPathData = 'M505.9 71.75c-8.961-9.781-24.18-10.37-33.95-1.406c-9.759 8.969-10.4 24.16-1.423 33.91c77.04 83.69 77.04 219.8 0 303.5c-8.977 9.75-8.336 24.94 1.423 33.91C476.5 445.9 482.4 448 488.2 448c6.475 0 12.95-2.594 17.69-7.75C599.4 338.7 599.4 173.3 505.9 71.75zM392.3 149.1c-9.962 8.75-10.95 23.91-2.19 33.87c34.97 39.78 34.97 104.5 0 144.3c-8.758 9.969-7.772 25.12 2.19 33.87c4.567 3.1 10.21 5.969 15.84 5.969c6.678 0 13.32-2.75 18.06-8.156c50.33-57.25 50.33-150.4 0-207.7C417.4 142.2 402.3 141.2 392.3 149.1zM104.1 70.35c-9.728-8.969-24.94-8.375-33.95 1.406c-93.51 101.6-93.51 266.9 0 368.5C74.87 445.4 81.34 448 87.82 448c5.818 0 11.65-2.094 16.26-6.344c9.759-8.969 10.4-24.16 1.423-33.91c-77.04-83.69-77.04-219.8 0-303.5C114.5 94.5 113.8 79.32 104.1 70.35zM183.7 149.1C173.8 141.2 158.6 142.2 149.8 152.2c-50.33 57.25-50.33 150.4 0 207.7c4.739 5.406 11.39 8.156 18.06 8.156c5.614 0 11.28-1.969 15.84-5.969c9.962-8.75 10.95-23.91 2.19-33.87c-34.97-39.78-34.97-104.5 0-144.3C194.7 173.9 193.7 158.7 183.7 149.1zM288 216c-22.11 0-40.02 17.91-40.02 39.1S265.9 296 288 296s40.02-17.91 40.02-39.1S310.1 216 288 216z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignalStream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;